export enum EntityStatusTypes {
    NEW = 'NEW',
    NOT_PUBLISHED = 'NOT PUBLISHED',
    PUBLISHED = 'PUBLISHED',
    HAS_CHANGED = 'HAS CHANGED',
    ACTIVE = 'ACTIVE',
    DISABLED = 'NOT ACTIVE',
    DELETED = 'DELETED'
}
